import $ from 'jquery';
import { Functions } from '../helpers';

export class Popup {

	constructor( App ) {
		Popup.App      = App;
		Popup.UI       = App.PwnUI;
		Popup.settings = App.settings;
        this.$element  = $( '.c-sbox-modal' );
		this.$field    = $( '.js-pwn-c-sbox-input-field' );
		this.$content  = $( '.c-sbox-content' );
		this.$open     = $( '.js-pwn-popup-open' );
		this.$close    = $( '.js-pwn-popup-close' );
		this.shown     = false;
		this.initialize();
	};

	initialize() {
    	this.$open.on( 'click', ( e ) => {
    		if ( e ) {
    			e.preventDefault();
    			e.stopPropagation();
    		}

    		if ( ! this.shown ) {
    			this.open();
    		}
    	} );

    	this.$close.on( 'click', ( e ) => {
    		if ( e ) {
    			e.preventDefault();
    			e.stopPropagation();
    		}

    		if ( this.shown ) {
    			this.close();
    		}
    	} );

    	Popup.UI.$document.on( 'click', ( e ) => {
    		if ( this.shown && ( ! this.$content.is( e.target ) && this.$content.has( e.target ).length === 0 ) ) {
    			this.close();
    		}
    	} );

    	Popup.UI.$document.on( 'keydown', ( e ) => {
    		if ( this.shown ) {
    			var keyCode = e.keyCode || e.which;

    			if ( keyCode === 27 ) {
    				this.close();
    			}
    		}
    	} );
	};

	open() {
		Popup.UI.$body.addClass( 'c-sbox-modal-open' );
		this.shown = true;
	};

	close() {
		Popup.UI.$body.removeClass( 'c-sbox-modal-open' );
		this.shown = false;
	}
}
